/*
 * @Author: Teemo Ding
 * @Date: 2021-06-28 13:56:01
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 13:11:07
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Invoice/InvoiceFormat/index.tsx
 */

import { Input, Label } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Form } from 'antd';
import React from 'react';
import css from '../css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const InvoiceFormat = ({
  disabled,
  disableEdit,
}: {
  disabled?: boolean;
  disableEdit?: boolean;
}) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.invoiceFormat}
      title={getI18n('storeInvoice.detail.invoiceIDFormat')}>
      <div className={css.invoiceFormatTitle}>
        {getI18n('storeInvoice.detail.invoiceIDFormat')}
      </div>
      <p>{getI18n('storeInvoice.detail.invoiceIDFormatTip')}</p>
      {disabled ? null : (
        <React.Fragment>
          <Row
            elements={[
              {
                child: (
                  <Form.Item
                    name='prefix'
                    labelCol={{
                      span: 24,
                    }}
                    rules={[
                      {
                        pattern: /^[0-9a-zA-Z-]{1,}$/,
                        message: getI18n('general.invalidformat'),
                      },
                    ]}
                    label={
                      <Label title={getI18n('storeInvoice.detail.prefix')} />
                    }>
                    <Input
                      size='large'
                      className={css.input}
                      disabled={disableEdit}
                    />
                  </Form.Item>
                ),
              },
              {
                child: (
                  <Form.Item
                    name='nextNumber'
                    labelCol={{
                      span: 24,
                    }}
                    rules={[
                      {
                        required: true,
                        message: 'Next Number Is Required.',
                      },
                      {
                        pattern: /^[1-9]\d*$/,
                        message: getI18n('general.invalidformat'),
                      },
                    ]}
                    label={
                      <Label
                        title={getI18n('storeInvoice.detail.nextNumber')}
                      />
                    }>
                    <Input
                      size='large'
                      maxLength={20}
                      className={css.input}
                      disabled={disableEdit}
                    />
                  </Form.Item>
                ),
              },
              {
                child: (
                  <Form.Item
                    name='suffix'
                    labelCol={{
                      span: 24,
                    }}
                    rules={[
                      {
                        pattern: /^[0-9a-zA-Z-]{1,}$/,
                        message: getI18n('general.invalidformat'),
                      },
                    ]}
                    label={
                      <Label title={getI18n('storeInvoice.detail.suffix')} />
                    }>
                    <Input
                      size='large'
                      className={css.input}
                      disabled={disableEdit}
                    />
                  </Form.Item>
                ),
              },
            ]}
          />
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, curValues) =>
              prevValues.prefix !== curValues.prefix ||
              prevValues.nextNumber !== curValues.nextNumber ||
              prevValues.suffix !== curValues.suffix
            }>
            {({ getFieldValue }) =>
              getFieldValue('prefix') ||
              /^[1-9]\d*$/.test(getFieldValue('nextNumber')) ||
              getFieldValue('suffix') ? (
                <p>
                  {getI18n('storeInvoice.detail.display')}
                  <span className={css.greenText}>
                    {' '}
                    {getFieldValue('prefix')}
                    {/^[1-9]\d*$/.test(getFieldValue('nextNumber')) &&
                      getFieldValue('nextNumber')}
                    {getFieldValue('suffix')},
                  </span>
                  <span className={css.greenText}>
                    {' '}
                    {getFieldValue('prefix')}
                    {/^[1-9]\d*$/.test(getFieldValue('nextNumber')) &&
                      (
                        BigInt(getFieldValue('nextNumber')) + BigInt(1)
                      ).toString()}
                    {getFieldValue('suffix')} ,
                  </span>
                  <span className={css.greenText}>
                    {' '}
                    {getFieldValue('prefix')}
                    {/^[1-9]\d*$/.test(getFieldValue('nextNumber')) &&
                      (
                        BigInt(getFieldValue('nextNumber')) + BigInt(2)
                      ).toString()}
                    {getFieldValue('suffix')} ...
                  </span>
                </p>
              ) : (
                getI18n('storeInvoice.detail.display')
              )
            }
          </Form.Item>
        </React.Fragment>
      )}
    </SectionWrapper>
  );
};

export default InvoiceFormat;
